import * as types from '../actions/typeNames'
import { findElementByPropName } from '../services/service'
import { tabButtons, templates } from '../defaults/templates'

const InitialState = {
    tab: undefined,
    template: "blank",
    description: "",
    selectedElementFromList: { id: 0, title:"-- Choose Element --" },
    editingElement: null,        
    ownerEmail: "",
    successMessage: "Success! Message received. Thank you.",
    errorMessage: "An error has been encountered. Please try again.",
    title: "Blank",
    submitText: "Submit",
    elements: [
        
    ],
    showAddForm: false,
    fromEditor: false
}

const setDefaultsByTemplate = (settings, template) => {
    settings.form.FormType = template.formType;
    settings.template = template.name;
    settings.description = template.description;
    if(settings.form.FormId <= 0){        
        settings.title = template.title;
        settings.elements = template.elements.map((element) => {
            return {...element}
        });
    }
    
}

const setSettingsByForm = (settings, form, config) => {
    if(config.settings !== null){
        settings.template = config.settings.template
        settings.description = findElementByPropName(templates, "name", config.settings.template).description;
        settings.title = config.settings.title
        settings.ownerEmail = config.settings.ownerEmail
        settings.successMessage = config.settings.successMessage
        settings.submitText = config.settings.submitText
        settings.elements = config.settings.elements.map((element) => {
            return {...element}
        });
    }else{
        let template = findElementByPropName(templates, "formType", form.FormType) 
        setDefaultsByTemplate(settings, template)
    }    
}



const setSettings = (settings, form, config, fromEditor) => {
    settings.form = {...form}
    if(form.FormId > 0){        
        setSettingsByForm(settings, form, config)

        // now we should set the default value for is_disblaed(and probably is_hidden) for EXISTING forms
        for (let t of tabButtons) {
            t.is_disabled = false;
            t.is_hidden = t.name == "templates";  // only templates should be hidden
        }
        if (settings.tab.id === 1) {
            settings.tab = findElementByPropName(tabButtons, "id", 2) // 1 is hidden
        }
        settings.showAddForm = true;
        if (fromEditor === !!fromEditor) {
            // only change it if it was specified
            settings.fromEditor = fromEditor
        }

    }else{
        setDefaultsByTemplate(settings, templates[0])
        settings.editingElement = null
        settings.tab = findElementByPropName(tabButtons, "id", 1)
        // now we should set the default value for is_disblaed(and probably is_hidden) for NEW forms
        for (let t of tabButtons) {
            t.is_disabled = t.name !== "templates";
            t.is_hidden = t.name == 'preview';
        }
        settings.showAddForm = false;
        settings.fromEditor = false;
    }
}

const sendSaveNotificationToParent = (form) => {
    let data = {
        type: "refresh_form",
        id: form.FormId
    }
    window.parent.postMessage(JSON.stringify(data), "*")
}

const settings = (state = InitialState, action) => {
    let s = {...state};
    let id = 1
    let element = {}
    let option = {}
    switch(action.type){
        case types.SET_SETTINGS:
            setSettings(s, action.form, action.config, action.fromEditor)
            break;
        case types.RESET_SETTINGS:
            s = { ...InitialState}
            setSettings(s, action.form, action.config, action.fromEditor)
            break;
        case types.SET_CONFIG:
            setSettingsByForm(s, null, action.config)
            break;
        case types.SELECT_TAB:
            s.tab = findElementByPropName(tabButtons, "id", action.tab_id)
            s.tab.is_disabled = false; // disable the "disabled" from each tab we already visited 
            if (s.tab.name === "settings") {
                s.showAddForm = true;
            }
            break;
        case types.SELECT_DEFAULT_EDIT_TAB:
            // set the default tab for editing(we could end in a different tab when going editor>list>editor, after the first time)
            s.tab = findElementByPropName(tabButtons, "id", 2)
            break;
        case types.SELECT_TEMPLATE:
            setDefaultsByTemplate(s, action.template)
            break;
        case types.SET_FORM_NAME:
            s.form.Name = action.name
            break;
        case types.SELECT_ELEMENT_FOR_ADDING_TO_FORM:
            s.selectedElementFromList = action.element
            break;
        case types.CHANGE_FORM_ELEMENTS_LIST:
            s.elements = action.elements
            break;
        case types.CHANGE_FORM_OPTIONS_LIST:
            s.editingElement.options = action.options.map((option) => {
                return {...option}
            })
            if (s.editingElement && s.editingElement.id) {
                element = findElementByPropName(s.elements, "id", s.editingElement.id)
                if (element.hasOptions) {
                    element.options = s.editingElement.options.map((option) => {
                        return { ...option }
                    })
                }
            }
            break;
        case types.ADD_ELEMENT_TO_LIST:
            if(action.element.id > 0){
                let newElm = {...action.element}
                newElm.id = s.elements.length + 1;
                if(action.element.hasOptions){
                    newElm.options = action.element.options.map((option) => {
                        return {...option}
                    })
                }
                s.elements.push(newElm)
                s.editingElement = newElm
            }                
            break;
        case types.EDIT_ELEMENT:
            if(s.editingElement !== action.element){
                s.editingElement = {...action.element}
                if(action.element.hasOptions){
                    s.editingElement.options = action.element.options.map((option) => {
                        return {...option}
                    })
                }
            }                         
            break;
        case types.ADD_OPTION_TO_LIST:            
            id = s.editingElement.options.length + 1;
            option = {
                id: id,
                value: `Option ${id}`
            }
            if(["checklist", "radio"].includes(s.editingElement.name)){
                option.checked = false
            }
            s.editingElement.options.push(option)
            // save changes
            if (s.editingElement && s.editingElement.id) {
                element = findElementByPropName(s.elements, "id", s.editingElement.id)
                if (element.hasOptions) {
                    element.options = s.editingElement.options.map((option) => {
                        return { ...option }
                    })
                }
            }
            break;
        case types.DELETE_ELEMENT_FROM_LIST:
            id = 1
            if(action.listName === "element"){
                s.elements = s.elements.filter((e) => {
                    return e.id !== action.element.id
                })                
                s.elements.forEach((e) => {e.id = id++;})
            }else if(action.listName === "option"){
                s.editingElement.options = s.editingElement.options.filter((e) => {
                    return e.id !== action.element.id
                })
                s.editingElement.options.forEach((e) => {e.id = id++;})
            }
            // save changes
            if (action.listName !== "element" && s.editingElement && s.editingElement.id) {
                element = findElementByPropName(s.elements, "id", s.editingElement.id)
                if (element.hasOptions) {
                    element.options = s.editingElement.options.map((option) => {
                        return { ...option }
                    })
                }
            }
            break;
        case types.CHANGE_ELEMENT_NAME:
            switch(action.kind){
                case 'title':
                    s.title = action.name
                    break;
                case 'submit':
                    s.submitText = action.name
                    break;
                case 'element':
                    element = findElementByPropName(s.elements, "id", action.id);
                    element.label = action.name
                    break;
                case 'option':
                    option = findElementByPropName(s.editingElement.options, "id", action.id);
                    option.value = action.name
                    // save changes
                    if (s.editingElement && s.editingElement.id) {
                        element = findElementByPropName(s.elements, "id", s.editingElement.id)
                        if (element.hasOptions) {
                            element.options = s.editingElement.options.map((option) => {
                                return { ...option }
                            })
                        }

                    }
                    break;
                case 'email': 
                    s.ownerEmail = action.name                   
                    break;
                case 'message':
                    s.successMessage = action.name
                    break;
                case 'error':
                    s.errorMessage = action.name
                    break;
                default:
                    break;
            }
            break;

        case types.SAVE_OPTIONS:
            element = findElementByPropName(s.elements, "id", s.editingElement.id)
            element.isHalf = s.editingElement.isHalf
            element.isRequired = s.editingElement.isRequired ?? false
            if(element.hasOptions){
                element.options = s.editingElement.options.map((option) => {
                    return {...option}
                })
            }
            s.editingElement = null
            break;

        case types.CHANGE_FLAG:
            s.editingElement.isHalf = action.flag
            // save changes
            if (s.editingElement && s.editingElement.id) {
                element = findElementByPropName(s.elements, "id", s.editingElement.id)
                element.isHalf = s.editingElement.isHalf
            }
            break;

        case types.CHANGE_ISREQUIRED_FLAG:
            s.editingElement.isRequired = action.flag
            if (s.editingElement && s.editingElement.id) {
                element = findElementByPropName(s.elements, "id", s.editingElement.id)
                element.isRequired = s.editingElement.isRequired ?? false
            }
            // save changes
            break;

        case types.CHANGE_CHECKBOX_OPTION:
            element = findElementByPropName(s.elements, "id", action.element_id)
            option = findElementByPropName(element.options, "id", action.option_id)
            option.checked = !option.checked
            if(option.checked)
                element.value.push(option)
            else
                element.value = element.value.filter(o => {return o.id != option.id})
            break;
        
        case types.DROPDOWN_CHOOSE_OPTION:            
        case types.RADIO_CHOOSE_OPTION:
        case types.TEXT_CHANGE:
            element = findElementByPropName(s.elements, "id", action.element_id)
            element.value = action.value
            break;

        case types.DATE_CHANGE:
            element = findElementByPropName(s.elements, "id", action.element_id)
            element.value = action.value
            break;
            
        case types.CLICK_SUBMIT:
            
            break;
        case types.SAVE_SUCCESS:
            sendSaveNotificationToParent(action.form)
            break;
        default:            
            if(state.tab === undefined){
                s.tab = findElementByPropName(tabButtons, "id", 1)                
            }        
    }
    return s;
}

export default settings;